class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this;
    this.sizeGuideToggleWrapper = document.querySelector('.product-form__size-guide')
    this.sizeguideToggle = document.querySelector('.size-guide-trigger');
    this.closeButton = document.querySelector('.size-guide__close');
    this.contentBlock = this.querySelectorAll('.size-guide__accordion-item-trigger')

    this.sizeGuideToggleWrapper.classList.add('is-active')
    this.sizeguideToggle.addEventListener('click', this.onToggleClick.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.contentBlock.forEach((button) => {
      button.addEventListener('click', this.openAccordion.bind(this))
    })

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close()
      }
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onToggleClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('size-guide__overlay')) {
      this.close(false)
    }
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('[tabindex="-1"]');
        const focusElement = this.querySelector('.size-guide__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.sizeguideToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }

  openAccordion(event) {
    if (event.target.classList.contains('is-active')) {
      event.target.classList.remove('is-active')

    } else {
      this.disableContentBlocks()
      event.target.classList.toggle('is-active')
    }
  }

  disableContentBlocks() {
    this.contentBlock.forEach((button) => {
      button.classList.remove('is-active')
    })
  }
}

customElements.define('size-guide-modal', SizeGuideModal);
